import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import ProfessionalGrowthDashboard from './components/ProfessionalGrowthDashboard';
import LoginScreen from './components/LoginScreen';
import ProtectedRoute from './components/ProtectedRoute';
import { useAuth } from './contexts/AuthContext';
import Dashboard from './components/Dashboard';
export function App() {
  const {
    login,
    error,
    isLoading,
    isAuthenticated
  } = useAuth();
  return <div className="w-full min-h-screen bg-gray-50" data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/login" element={isAuthenticated ? <Navigate to="/" replace data-id="element-3" /> : <LoginScreen onLogin={login} error={error || undefined} isLoading={isLoading} data-id="element-4" />} data-id="element-2" />
        <Route path="/" element={<ProtectedRoute data-id="element-6">
              <Dashboard data-id="element-7" />
            </ProtectedRoute>} data-id="element-5" />
        <Route path="/dashboard" element={<ProtectedRoute data-id="element-9">
              <ProfessionalGrowthDashboard activeTab="agent" data-id="element-10" />
            </ProtectedRoute>} data-id="element-8" />
        <Route path="/agent" element={<ProtectedRoute data-id="element-12">
              <ProfessionalGrowthDashboard activeTab="agent" data-id="element-13" />
            </ProtectedRoute>} data-id="element-11" />
        <Route path="/capacity" element={<ProtectedRoute data-id="element-15">
              <ProfessionalGrowthDashboard activeTab="graph" data-id="element-16" />
            </ProtectedRoute>} data-id="element-14" />
        <Route path="/branching" element={<ProtectedRoute data-id="element-18">
              <ProfessionalGrowthDashboard activeTab="branching" data-id="element-19" />
            </ProtectedRoute>} data-id="element-17" />
        <Route path="/beacon" element={<ProtectedRoute data-id="element-21">
              <ProfessionalGrowthDashboard activeTab="beacon" data-id="element-22" />
            </ProtectedRoute>} data-id="element-20" />
      </Routes>
    </div>;
}